var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9257 2.80901C27.8454 3.27842 26.7023 3.58768 25.5327 3.72701C26.7619 3.00724 27.6863 1.86374 28.1325 0.510992C26.9703 1.19055 25.701 1.66736 24.3789 1.921C23.8221 1.33752 23.1525 0.873337 22.4108 0.55668C21.6691 0.240022 20.8707 0.0774991 20.0642 0.0789897C16.799 0.0789897 14.1566 2.68301 14.1566 5.89303C14.1543 6.33953 14.2054 6.7847 14.309 7.21904C11.9676 7.10927 9.67487 6.51198 7.57753 5.46538C5.48019 4.41877 3.6244 2.9459 2.1289 1.141C1.60424 2.02547 1.32678 3.03463 1.3255 4.06301C1.3255 6.07903 2.3773 7.86104 3.96551 8.90505C3.02454 8.88271 2.10286 8.63367 1.2787 8.17904V8.25104C1.2787 11.0711 3.31871 13.4171 6.01873 13.9511C5.51099 14.0864 4.98778 14.155 4.46232 14.1551C4.08946 14.1557 3.71745 14.1196 3.35171 14.0471C4.10232 16.3571 6.28693 18.0371 8.87475 18.0851C6.77196 19.7057 4.19029 20.5816 1.5355 20.5751C1.06427 20.5744 0.593471 20.5464 0.125488 20.4911C2.82621 22.2157 5.9656 23.1279 9.16995 23.1191C20.0516 23.1191 25.9965 14.2571 25.9965 6.57103C25.9965 6.31903 25.9899 6.06703 25.9779 5.82103C27.1317 5.00026 28.13 3.98028 28.9257 2.80901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.9d2ce4d99919e84951fb7bd2975341e5.svg";
export { ForwardRef as ReactComponent };